<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>

<div id="header-container">
  <h1 class="title"> {{ displayHeader }} </h1>
  <div class="button-container">
    <div id="create-container" [hidden]="isEdit === true">
      <button mat-raised-button color="primary" id="create-button"
              class="action-button" (click)="onCreate()" [disabled]="!globalScenarioForm.valid">
        Create
      </button>
    </div>
    <div id="update-container" [hidden]="isEdit === false">
      <button mat-raised-button color="primary" id="update-button" class="action-button"
              (click)="onUpdate()">
        Update
      </button>
    </div>
    <div id="cancel-container">
      <button mat-stroked-button color="primary" id="cancel-button" class="action-button"
              (click)="openGlobalScenarioPage()">
        Cancel
      </button>
    </div>
  </div>
</div>

<form [formGroup]="globalScenarioForm" class="add-global-scenario-form">
  <mat-form-field class="full-width">
    <input
      maxlength="35"
      [(ngModel)]="selectedGlobalScenario.globalScenarioName"
      matInput
      formControlName="globalScenarioName"
      placeholder="Global Scenario Name:"/>
  </mat-form-field>
</form>
<form class="search-vehicle-scenario-form">
  <mat-form-field class="full-width">
    <input
      [(ngModel)]="searchVehicleScenarioIdsString" [ngModelOptions]="{standalone: true}"
      matInput
      placeholder="Enter Scenario IDs to select ex: 25,57,112,256"
      (keydown.enter)="onSearchVehicleScenarios(searchVehicleScenarioIdsString)"/>
  </mat-form-field>
</form>

<div id="vehicle-scenarios-container">
  <mat-card appearance="outlined" class="d-flex flex-column gap-16 mat-card-container default-padding">
    <div class="available-scenario-header d-flex justify-content-between gap-8 flex-column">
      <mat-card-title>Available Scenarios</mat-card-title>
      <div class="d-flex gap-8 align-items-baseline">
        <mat-checkbox [(ngModel)]="isHidden" (change)="setAvailableVehicleScenarioData()">
          Show Hidden Scenarios
        </mat-checkbox>
      </div>
    </div>
    <div [hidden]="noData" class="gfs-table available-table">
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="displayedVehicleScenarios"
        [columnDefs]="columnDefs"
        [autoSizeStrategy]="autoSizeStrategy"
        [rowSelection]="rowSelection"
        (rowSelected)="onSelect($event)"
        (gridReady)="onAvailableGridReady($event)"
      ></ag-grid-angular>
    </div>
  </mat-card>

  <div class="actions-container">
    <button mat-icon-button
            matTooltip="Move selected scenario to Global Scenario"
            (click)="addToGlobalScenario(selectedVehicleScenario)"
            id="add-mapping"
            class="scenario-action-icon"
            [disabled]="!this.selectedVehicleScenario || this.displayedVehicleScenarios.indexOf(this.selectedVehicleScenario) === -1">
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
    <button mat-icon-button
            matTooltip="Remove selected scenario from Global Scenario"
            (click)="removeFromGlobalScenario(selectedMemberScenario)"
            id="delete-mapping"
            class="scenario-action-icon"
            [disabled]="!this.selectedMemberScenario || this.memberVehicleScenarios.indexOf(this.selectedMemberScenario) === -1">

    <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>
  </div>

  <mat-card appearance="outlined" class="mat-card-container default-padding">
    <mat-card-title>Member Scenarios For This New Global Scenario</mat-card-title>
    <div [hidden]="noData" class="gfs-table selected-table">
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="memberVehicleScenarios"
        [columnDefs]="columnDefs"
        [autoSizeStrategy]="autoSizeStrategy"
        [rowSelection]="rowSelection"
        (rowSelected)="onSelectMember($event)"
        (gridReady)="onMemberGridReady($event)"
      ></ag-grid-angular>
    </div>
  </mat-card>
</div>
